import { MdTypography } from '@antiqua-dls/vue-components'

export default {
  name: 'VerifyEmailPage',
  components: { MdTypography },
  methods: {
    openEmailVerificationModal() {
      this.$emit('openEmailVerificationModal');
    },
  },
}
